import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'timePeriod',
    standalone: false
})
export class TimePeriodPipe implements PipeTransform {
  transform(totalSeconds) {
    if (totalSeconds >= 60) {
      const minutes = Math.floor(totalSeconds / 60);
      return minutes.toString() + 'm ' + Math.floor((totalSeconds - minutes * 60)).toString() + 's';
    }
    else {
      return Math.floor(totalSeconds).toString() + 's';
    }
  }
}
